import axios from "axios";
import RegisterUserForm from "./RegisterUserForm";
import { FetchUser } from "./User";
import UserApiRoute from "./UserApiRoute";
import SaveProfileRequest from "./partner/SaveProfileRequest";
import RegisterUserResponse from "./RegisterUserResponse";
import DeleteProfilePhotosRequest from "./partner/DeleteProfilePhotosRequest";
import SavePartnerProfileResponseBody from "./partner/response/SavePartnerProfileResponseBody";
import UpdatePartnerProfileRequestBody from "./partner/UpdatePartnerProfileRequestBody";

export default class UserApi {
  async create(form: RegisterUserForm) {
    return axios.post(UserApiRoute.CREATE, form, {
      withCredentials: true,
    });
  }

  async get(userId: string): Promise<FetchUser> {
    try {
      if (!userId) {
        return {};
      }
      const response = await axios.get<FetchUser>(
        `${UserApiRoute.USER}/${userId}?userId=${userId}`,
        {
          withCredentials: true,
        }
      );
      return response.data;
    } catch (err) {
      console.error(err);
      return {};
    }
  }

  async createPartnerProfile(
    userId: string,
    form: SaveProfileRequest
  ): Promise<SavePartnerProfileResponseBody> {
    const response = await axios.post(
      `${UserApiRoute.PROFILE}/partner/${userId}?userId=${userId}`,
      form,
      {
        withCredentials: true,
      }
    );
    return response.data;
  }

  async updatePartnerProfile(
    userId: string,
    form: UpdatePartnerProfileRequestBody
  ): Promise<SavePartnerProfileResponseBody> {
    const response = await axios.put(
      `${UserApiRoute.PROFILE}/partner/${userId}?userId=${userId}`,
      form,
      {
        withCredentials: true,
      }
    );
    return response.data;
  }

  async updateProfilePhotos(
    userId: string,
    form: FormData
  ): Promise<RegisterUserResponse> {
    const response = await axios.post(
      `${UserApiRoute.PHOTO}/${userId}?userId=${userId}`,
      form,
      {
        withCredentials: true,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data;
  }

  async deleteProfilePhotos(
    userId: string,
    form: DeleteProfilePhotosRequest
  ): Promise<RegisterUserResponse> {
    const response = await axios.post(
      `${UserApiRoute.DELETE_PHOTO}/${userId}?userId=${userId}`,
      form,
      {
        withCredentials: true,
      }
    );
    return response.data;
  }

  async updateWorkerAvatars(
    userId: string,
    form: FormData
  ): Promise<RegisterUserResponse> {
    const response = await axios.post(
      `${UserApiRoute.WORKER_PHOTO}/${userId}?userId=${userId}`,
      form,
      {
        withCredentials: true,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data;
  }

  async delete(userId: string) {
    return axios.delete(`${UserApiRoute.USER}/${userId}?userId=${userId}`, {
      withCredentials: true,
    });
  }

  async updateNotificationToken(userId: string, token: string) {
    const response = await axios.put(
      `${UserApiRoute.USER_NOTIFICATION}/${userId}?userId=${userId}`,
      { token },
      {
        withCredentials: true,
      }
    );
  }
}
